import { render, staticRenderFns } from "./AppFormControlFileUploadComponent.vue?vue&type=template&id=70ddb13a&"
import script from "./AppFormControlFileUploadComponent.ts?vue&type=script&lang=ts&"
export * from "./AppFormControlFileUploadComponent.ts?vue&type=script&lang=ts&"
import style0 from "./AppFormControlFileUploadComponent.global.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports